import { render, staticRenderFns } from "./LotListItemSkelleton.vue?vue&type=template&id=311f6481&"
import script from "./LotListItemSkelleton.vue?vue&type=script&lang=js&"
export * from "./LotListItemSkelleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports